import React, { FunctionComponent } from 'react';
import classnames from 'classnames';
import './oe-radio-options.scss';
import classNames from 'classnames';
import Text from '../text/text';
import { OptionIconChecked } from './option-icon';

interface IRadioButtonOption {
    label?: string;
    id?: string;
    value: string;
    icon?: FunctionComponent;
    content?: JSX.Element;
}

interface IProps {
    options: IRadioButtonOption[];
    value: string;
    onOptionToggle: (value: string) => void;
    disabled?: boolean;
    width?: string;
    uncheckClick?: boolean;
    greyHoverStyle?: boolean;
    styles?: string;
    optionsId?: string;
    shouldHideRadioButton?: boolean;
    isIconFirst?: boolean;
}

const OERadioOptions = (props: IProps) => {
    const {
        onOptionToggle,
        uncheckClick,
        options,
        value,
        width,
        disabled,
        styles,
        greyHoverStyle = false,
        optionsId = '',
        shouldHideRadioButton,
        isIconFirst,
    } = props;

    const handleClick = (optionValue: string, propsValue: string) => {
        onOptionToggle(optionValue);
        if (uncheckClick && optionValue === propsValue) {
            onOptionToggle(null);
        }
    };

    return (
        <div className={classnames(styles, 'oe-radio-option__options', {
            'oe-radio-option__options--icon-first': isIconFirst,
        })}>
            {options.map(option => (
                <div
                    key={option.value}
                    className={classnames('oe-radio-option', {
                        'oe-radio-option--selected': option.value === (value || null),
                        'oe-radio-option--selected-with-background': shouldHideRadioButton && option.value === (value || null),
                        'oe-radio-option--icon-first': isIconFirst,
                        'oe-radio-option--placeholder': !option.value,
                    })}
                    style={{ width: width ? width : 'auto' }}
                    onClick={() => handleClick(option.value, value)}
                >
                    <input
                        type='radio'
                        id={`radio-button-${optionsId}${option.value}`}
                        className='oe-radio-option__control'
                        defaultChecked={option.value === value}
                        readOnly={disabled}
                    />
                    <label htmlFor={`radio-button-${optionsId}${option.value}`}
                        className={classNames('oe-radio-option__label', {
                            'oe-radio-option__label--grey-hover': greyHoverStyle,
                        })}>
                        { !shouldHideRadioButton && <OptionIconChecked /> }
                        { option.content || (
                            <Text
                                className={classnames('oe-radio-option__label-text', {
                                    'oe-radio-option__label-text--disabled': props.disabled
                                })}
                                id={option.id}
                                message={option.label}
                                withEllipsis
                            />
                        )}
                    </label>
                    {!!option.icon && (
                        <div className='oe-radio-option__icon'>
                            <option.icon />
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export { OERadioOptions, IRadioButtonOption };
